module.exports = __webpack_public_path__ + "static/media/See-how-it-works.823c6bab.jpg";